import { Fragment } from 'react';
import { Menu } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { FormSubmitButton } from './FormSubmitButton';
export function NumberField() {
    const [field, , helpers] = useField('value');
    const handleChange = (value) => {
        const numberValue = parseInt(value, 10);
        if (Number.isNaN(numberValue)) {
            return undefined;
        }
        return helpers.setValue(numberValue);
    };
    return (<Fragment>
      <Menu.HeaderInput type="number" value={`${field.value}`} onChange={handleChange}/>
      <FormSubmitButton />
    </Fragment>);
}
